import type { AxiosResponse } from 'axios';

import type { DuplicatedOrderStatus } from '~/types/Order';
import { microServiceAPI } from '~/services/api';
import { WEB_ORDERS_API } from '~/services/web-orders.service';

/**
 * Retrieves the status of a duplicated order.
 *
 * This function makes a server request to obtain the current status of an order
 * that has been duplicated. It requires the IDs of both the original and the
 * cloned order.
 *
 * @param {string} originalOrderId - The ID of the original order.
 * @param {string} clonedOrderId - The ID of the duplicated (cloned) order.
 *
 * @return {Promise<AxiosResponse<DuplicatedOrderStatus>>} - A promise resolving to the server response,
 * containing the status of the duplicated order.
 */
export function getOrderStatus(
  originalOrderId: string,
  clonedOrderId: string,
): Promise<AxiosResponse<DuplicatedOrderStatus>> {
  return microServiceAPI.request({
    url: `${WEB_ORDERS_API}/${originalOrderId}/clone/${clonedOrderId}`,
    method: 'GET',
  });
}
